import { IntegrationExportEntity } from "@nova/constants"
import { TAKHotspotOptions } from "@nova/data-create-hotspots-kml"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWRMutation from "swr/mutation"

type ExportEntity = { id: string } & (
    | { type: IntegrationExportEntity.InfraredFlight; options: TAKHotspotOptions }
    | { type: IntegrationExportEntity; options?: undefined }
)

interface TAKExportRequest {
    workspaceId: string
    projectId: string
    entities: ExportEntity[]
    mergedFlightId?: string
}

const useExportToTAK = () => {
    const { trigger: exportToTAK, isMutating } = useSWRMutation(
        "tak-export",
        async (_key: string, { arg }: { arg: TAKExportRequest }) => {
            const res = await fetchApiGateway("post /org/:orgId/integrations/tak/export", {
                params: { orgId: arg.workspaceId },
                body: {
                    projectId: arg.projectId,
                    entities: arg.entities,
                    mergedFlightId: arg.mergedFlightId,
                },
                rawResponse: true,
            })

            if (!res.ok || res.status === 204) throw new Error("Unable to export to TAK")
            return res
        }
    )

    return { exportToTAK, isMutating }
}

export { useExportToTAK }
export type { TAKExportRequest, ExportEntity }
